import RemarksConfirmModal from "../../LessonPlanner/components/RemarksConfirmModal";

/** Principal approves a teacher's weekly diary; the API is called only on "Done". */
const ApproveDiaryModal = ({ isOpen, teacherName, weekLabel, isDiarySubmitted = true, isSubmitting, onClose, onSubmit }) => (
  <RemarksConfirmModal
    isOpen={isOpen}
    title="Approve Diary"
    message={
      <>
        Are you sure you want to approve diary of <strong>“{teacherName}”</strong> for <strong>“{weekLabel}”</strong>
      </>
    }
    label="Your Remarks"
    placeholder="Share feedback on this week's teaching..."
    isSubmitting={isSubmitting}
    onClose={onClose}
    onSubmit={onSubmit}
  >
    {!isDiarySubmitted && (
      <div className="wd-approve-note" role="note">
        The teacher has not submitted this diary or their weekly reflection yet.
      </div>
    )}
  </RemarksConfirmModal>
);

export default ApproveDiaryModal;
